import type { IActivityIconProps } from './helpers';

export const ActivityIcon = ({ variant, ...rest }: IActivityIconProps) => {
	if (variant === 'apple')
		return (
			<svg
				width='40'
				height='40'
				viewBox='0 0 40 40'
				fill='none'
				xmlns='http://www.w3.org/2000/svg'
				{...rest}
			>
				<g filter='url(#filter0_d_9801_147384)'>
					<circle
						cx='20'
						cy='16'
						r='16'
						fill='#E4ECFB'
					/>
					<path
						fillRule='evenodd'
						clipRule='evenodd'
						d='M24.7334 20.7727C25.1267 20.1727 25.2734 19.866 25.5734 19.1927C23.36 18.3527 23.0067 15.1993 25.1934 13.9927C24.5267 13.1527 23.5867 12.666 22.7 12.666C22.06 12.666 21.62 12.8327 21.2267 12.986C20.8934 13.1127 20.5934 13.226 20.22 13.226C19.82 13.226 19.4667 13.0994 19.0934 12.966C18.6867 12.8194 18.26 12.666 17.7267 12.666C16.7334 12.666 15.6734 13.2727 15 14.3127C14.0534 15.7793 14.22 18.526 15.7467 20.8727C16.2934 21.7127 17.0267 22.6527 17.98 22.666C18.38 22.6727 18.64 22.5527 18.9267 22.426C19.2534 22.2794 19.6067 22.1193 20.2267 22.1193C20.8467 22.1127 21.1934 22.2794 21.52 22.426C21.8 22.5527 22.0534 22.6727 22.4467 22.666C23.4134 22.6527 24.1867 21.6127 24.7334 20.7727Z'
						fill='#022745'
					/>
					<path
						fillRule='evenodd'
						clipRule='evenodd'
						d='M22.56 9.33398C22.6667 10.0673 22.3667 10.794 21.9734 11.3007C21.5534 11.8473 20.82 12.274 20.1134 12.2473C19.9867 11.5406 20.3134 10.814 20.7134 10.3273C21.16 9.79398 21.9134 9.38065 22.56 9.33398Z'
						fill='#022745'
					/>
				</g>
				<defs>
					<filter
						id='filter0_d_9801_147384'
						x='0'
						y='0'
						width='40'
						height='40'
						filterUnits='userSpaceOnUse'
						colorInterpolationFilters='sRGB'
					>
						<feFlood
							floodOpacity='0'
							result='BackgroundImageFix'
						/>
						<feColorMatrix
							in='SourceAlpha'
							type='matrix'
							values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
							result='hardAlpha'
						/>
						<feOffset dy='4' />
						<feGaussianBlur stdDeviation='2' />
						<feComposite
							in2='hardAlpha'
							operator='out'
						/>
						<feColorMatrix
							type='matrix'
							values='0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.2 0'
						/>
						<feBlend
							mode='normal'
							in2='BackgroundImageFix'
							result='effect1_dropShadow_9801_147384'
						/>
						<feBlend
							mode='normal'
							in='SourceGraphic'
							in2='effect1_dropShadow_9801_147384'
							result='shape'
						/>
					</filter>
				</defs>
			</svg>
		);

	if (variant === 'android')
		return (
			<svg
				width='40'
				height='40'
				viewBox='0 0 40 40'
				fill='none'
				xmlns='http://www.w3.org/2000/svg'
				{...rest}
			>
				<g filter='url(#filter0_d_9801_147393)'>
					<circle
						cx='20'
						cy='16'
						r='16'
						fill='#E4ECFB'
					/>
					<path
						d='M19.3333 20V22C19.3333 22.3667 19.0333 22.6667 18.6667 22.6667C18.3 22.6667 18 22.3667 18 22V20H19.3333Z'
						fill='#022745'
					/>
					<path
						d='M22.0001 20V22C22.0001 22.3667 21.7001 22.6667 21.3334 22.6667C20.9667 22.6667 20.6667 22.3667 20.6667 22V20H22.0001Z'
						fill='#022745'
					/>
					<path
						d='M23.3334 15.3333V18.6667C23.3334 19.4 22.7334 20 22.0001 20H18.0001C17.2667 20 16.6667 19.4 16.6667 18.6667V15.3333C16.6667 14.6 17.2667 14 18.0001 14H22.0001C22.7334 14 23.3334 14.6 23.3334 15.3333Z'
						fill='#022745'
					/>
					<path
						d='M15.3333 15.3327V17.9993C15.3333 18.366 15.0333 18.666 14.6667 18.666C14.3 18.666 14 18.366 14 17.9993V15.3327C14 14.966 14.3 14.666 14.6667 14.666C15.0333 14.666 15.3333 14.966 15.3333 15.3327Z'
						fill='#022745'
					/>
					<path
						d='M26.0001 15.3327V17.9993C26.0001 18.366 25.7001 18.666 25.3334 18.666C24.9667 18.666 24.6667 18.366 24.6667 17.9993V15.3327C24.6667 14.966 24.9667 14.666 25.3334 14.666C25.7001 14.666 26.0001 14.966 26.0001 15.3327Z'
						fill='#022745'
					/>
					<path
						d='M18.3999 13.0673H21.5999C22.1866 13.0673 22.6666 12.5873 22.6666 12.0007C22.6666 10.5273 21.4733 9.33398 19.9999 9.33398C18.5266 9.33398 17.3333 10.5273 17.3333 12.0007C17.3333 12.5873 17.8132 13.0673 18.3999 13.0673Z'
						fill='#022745'
					/>
				</g>
				<defs>
					<filter
						id='filter0_d_9801_147393'
						x='0'
						y='0'
						width='40'
						height='40'
						filterUnits='userSpaceOnUse'
						colorInterpolationFilters='sRGB'
					>
						<feFlood
							floodOpacity='0'
							result='BackgroundImageFix'
						/>
						<feColorMatrix
							in='SourceAlpha'
							type='matrix'
							values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
							result='hardAlpha'
						/>
						<feOffset dy='4' />
						<feGaussianBlur stdDeviation='2' />
						<feComposite
							in2='hardAlpha'
							operator='out'
						/>
						<feColorMatrix
							type='matrix'
							values='0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.2 0'
						/>
						<feBlend
							mode='normal'
							in2='BackgroundImageFix'
							result='effect1_dropShadow_9801_147393'
						/>
						<feBlend
							mode='normal'
							in='SourceGraphic'
							in2='effect1_dropShadow_9801_147393'
							result='shape'
						/>
					</filter>
				</defs>
			</svg>
		);

	if (variant === 'iphone')
		return (
			<svg
				width='40'
				height='40'
				viewBox='0 0 40 40'
				fill='none'
				xmlns='http://www.w3.org/2000/svg'
				{...rest}
			>
				<g filter='url(#filter0_d_9801_147423)'>
					<circle
						cx='20'
						cy='16'
						r='16'
						fill='#E4ECFB'
					/>
					<path
						opacity='0.4'
						d='M26.6466 12.274V16.6073H13.3333V12.274C13.3333 10.654 14.6533 9.33398 16.2733 9.33398H23.7066C25.3266 9.33398 26.6466 10.654 26.6466 12.274Z'
						fill='#022745'
					/>
					<path
						d='M13.3333 16.6133V16.7466C13.3333 18.3733 14.6533 19.6866 16.2733 19.6866H18.8333C19.1999 19.6866 19.4999 19.9866 19.4999 20.3533V20.9999C19.4999 21.3666 19.1999 21.6666 18.8333 21.6666H17.2199C16.9466 21.6666 16.7199 21.8933 16.7199 22.1666C16.7199 22.4399 16.9399 22.6666 17.2199 22.6666H22.7866C23.0599 22.6666 23.2866 22.4399 23.2866 22.1666C23.2866 21.8933 23.0599 21.6666 22.7866 21.6666H21.1733C20.8066 21.6666 20.5066 21.3666 20.5066 20.9999V20.3533C20.5066 19.9866 20.8066 19.6866 21.1733 19.6866H23.7133C25.3399 19.6866 26.6533 18.3666 26.6533 16.7466V16.6133H13.3333Z'
						fill='#022745'
					/>
				</g>
				<defs>
					<filter
						id='filter0_d_9801_147423'
						x='0'
						y='0'
						width='40'
						height='40'
						filterUnits='userSpaceOnUse'
						colorInterpolationFilters='sRGB'
					>
						<feFlood
							floodOpacity='0'
							result='BackgroundImageFix'
						/>
						<feColorMatrix
							in='SourceAlpha'
							type='matrix'
							values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
							result='hardAlpha'
						/>
						<feOffset dy='4' />
						<feGaussianBlur stdDeviation='2' />
						<feComposite
							in2='hardAlpha'
							operator='out'
						/>
						<feColorMatrix
							type='matrix'
							values='0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.2 0'
						/>
						<feBlend
							mode='normal'
							in2='BackgroundImageFix'
							result='effect1_dropShadow_9801_147423'
						/>
						<feBlend
							mode='normal'
							in='SourceGraphic'
							in2='effect1_dropShadow_9801_147423'
							result='shape'
						/>
					</filter>
				</defs>
			</svg>
		);

	return (
		<svg
			width='40'
			height='40'
			viewBox='0 0 40 40'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
			{...rest}
		>
			<g filter='url(#filter0_d_433_5223)'>
				<circle
					cx='20'
					cy='16'
					r='16'
					fill='#E4ECFB'
				/>
			</g>
			<rect
				x='14'
				y='14'
				width='13'
				height='3'
				fill='#022745'
			/>
			<defs>
				<filter
					id='filter0_d_433_5223'
					x='0'
					y='0'
					width='40'
					height='40'
					filterUnits='userSpaceOnUse'
					colorInterpolationFilters='sRGB'
				>
					<feFlood
						floodOpacity='0'
						result='BackgroundImageFix'
					/>
					<feColorMatrix
						in='SourceAlpha'
						type='matrix'
						values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
						result='hardAlpha'
					/>
					<feOffset dy='4' />
					<feGaussianBlur stdDeviation='2' />
					<feComposite
						in2='hardAlpha'
						operator='out'
					/>
					<feColorMatrix
						type='matrix'
						values='0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.2 0'
					/>
					<feBlend
						mode='normal'
						in2='BackgroundImageFix'
						result='effect1_dropShadow_433_5223'
					/>
					<feBlend
						mode='normal'
						in='SourceGraphic'
						in2='effect1_dropShadow_433_5223'
						result='shape'
					/>
				</filter>
			</defs>
		</svg>
	);
};
